import Handlebars from 'handlebars/runtime'
import Moment from 'moment'




Handlebars.registerHelper('colorFskBadge', function(fsk){
    return window.theme.fskClass[fsk];
})
Handlebars.registerHelper('colorBtnPlaytime', function(btnPlaytime){
    return window.releaseCss[btnPlaytime];
})
Handlebars.registerHelper('dateTimeText', function(date){
    let dateTime = window.dateTimes[date]
    if(dateTime != null){
        return dateTime.text
    }
    if(date != null){
        return date
    }
    return ""
})
Handlebars.registerHelper('dateTimeTitle', function(date){
    let dateTime = window.dateTimes[date]
    if(dateTime != null){
        return dateTime.title
    }
    return ""
})
Handlebars.registerHelper('liesNotInPast', function(date){

    let mDate = Moment(date, 'yyyy-MM-dd')

    let now = Moment()

//    if (window.scheduleView == "standard") {
        return !((mDate.dayOfYear() < now.dayOfYear()) && mDate.year() == now.year())
 /*   } else {
        let mDate2 = Moment.unix(date.unixdate);
        let endtabledate = now.add(7, 'days')
        let time1 = mDate2.dayOfYear();
        let time2 = endtabledate.dayOfYear();
        let year1 = mDate2.year()
        let year2 = endtabledate.year()
       // console.log(year1)
       // console.log(year2);
       // console.log(time1)
       // console.log(time2);
       // console.log(time1 <  time2 && year1 == year2)

        return (time1 <  time2 && year1 == year2)

    }   */

})
Handlebars.registerHelper('isToday', function(date){
    let mDate = Moment(date)
    let now = Moment()
    return now.isSame(mDate, 'day')
})
Handlebars.registerHelper('ksort', ksort)
Handlebars.registerHelper('keyBySortBy', (arr, prop) => {
    let res1 = keyBy(arr, prop)
    return ksort(res1)
})
Handlebars.registerHelper('groupBykSort', (arr, prop) => {
    let groups = groupBy(arr, prop)
    let res = ksort(groups)
    return res
})
Handlebars.registerHelper('objectHasItems', arr => arr != null && Object.keys(arr).length > 0)

Handlebars.registerHelper('formatTime', (timeStr, format) => {
    let time = Moment(timeStr, "HH:mm:ss")
    return time.format(format)
})
Handlebars.registerHelper('formatDate', (dateStr, format) => {
    let date = Moment(dateStr, "YYYY-MM-DD").locale('de')
    return date.format(format)
})
Handlebars.registerHelper('getScheduleImage', (film, nr) =>{
    if(film == null || film.images == null){
        return null
    }
    let images = film.images['filmposter-schedule']
    if(images == null){
        return null
    }
    let imagesNr = images[nr]
    if(imagesNr == null){
        return null
    }
    return cdn + imagesNr['1']
})
Handlebars.registerHelper('getSolarScheduleImage', (film, nr) =>{
    if(film == null || film.solarPortraitImages == null){
      return null
    }
    let images = film.solarPortraitImages

    if(images == null){
      return null
    }
    let imagesNr = images[nr]
    if(imagesNr == null){
      return null
    }
    return imagesNr
})
Handlebars.registerHelper('getFilmDetailUrl', slug => {
            return "/programm/film/" + slug
})
Handlebars.registerHelper('windowObjectIsNotNull', obj => {
    return window[obj] != null
})
Handlebars.registerHelper('getFilmImageColumn', () => {
    return window.filmColumns.image
})
Handlebars.registerHelper('getFilmContentColumn', () => {
    return window.filmColumns.content
})
Handlebars.registerHelper('classFilmContentDescription', () => {
    return window.classFilmContentDescription
})
Handlebars.registerHelper('classFilmCreditsBoxMargins', () => {
    return window.classFilmCreditsBoxMargins
})
Handlebars.registerHelper('isArray', Array.isArray)
Handlebars.registerHelper('hasUnixdateProperty', obj => obj != null && obj['unixdate'] != null)
Handlebars.registerHelper('getCdn', () => {
    return window.mediaCdn
})
Handlebars.registerHelper('getParentalGuidance', () => {
    return window.parentalGuidance
})
Handlebars.registerHelper('getAllowedYoutubeTrailer', () => {
  return window.allowYoutubeTrailer
})
Handlebars.registerHelper('getMovieboxCityId', () => {
    return window.moviebox.city
})
Handlebars.registerHelper('getMovieboxBoxId', () => {
   return window.moviebox.moviebox
})

Handlebars.registerHelper('cinemaLogo', function(siteid){
    return window.scheduleSitePics[siteid];
})

Handlebars.registerHelper('hasCinemaLogo', function(siteid){
    return window.scheduleSitePics[siteid] != null;
})

Handlebars.registerHelper('getTrailerDisabledAttribute', (film) => {
    if ( (film.detailId || (film.trailer && film.trailerType )) && film.trailerAvailable ) {
        return '';
    }
    return 'disabled';
});
Handlebars.registerHelper('getTrailerAvailable', (film) => {
    if ( (film.detailId || (film.trailer && film.trailerType )) && film.trailerAvailable ) {
        return true;
    }
    return false;
});

Handlebars.registerHelper('getInfoDisabledAttribute', (film) => {
    if (film.text) {
        return '';
    }
    return 'disabled';
});

Handlebars.registerHelper('json', function(context) {
    return JSON.stringify(context);
});

Handlebars.registerHelper('compare', function(lvalue, rvalue, options) {

    if (arguments.length < 3)
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");

    var operator = options.hash.operator || "==";

    var operators = {
        '==':       function(l,r) { return l == r; },
        '===':      function(l,r) { return l === r; },
        '!=':       function(l,r) { return l != r; },
        '<':        function(l,r) { return l < r; },
        '>':        function(l,r) { return l > r; },
        '<=':       function(l,r) { return l <= r; },
        '>=':       function(l,r) { return l >= r; },
        'typeof':   function(l,r) { return typeof l == r; }
    }

    if (!operators[operator])
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator "+operator);

    var result = operators[operator](lvalue,rvalue);

    if( result ) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }

});

/**
 * @param {Array} arr
 * @param {string} groupBy
 */
function groupBy(arr, prop)
{
    if(typeof arr == 'object')
    {
        return Object.keys(arr).reduce((groups, key) => {
            let item = arr[key]
            const val = item[prop]
            groups[val] = groups[val] || []
            groups[val].push(item)
            return groups
        }, [])
    }
    return arr.reduce((groups, item) =>{
        const val = item[prop]
        groups[val] = groups[val] || []
        groups[val].push(item)
        return groups
    }, [])
}

Handlebars.registerHelper('isStandardView', () => {
    if (window.scheduleView == "standard") {
        return true
    } else {
        return false
    }

})

Handlebars.registerHelper('getDate' , (i , formated, short)  => {
    let res = getDate(i , formated, short)
    return res
})

Handlebars.registerHelper('compareDates', function(i , date2) {
    let date1 = getDate(i, false)
    if (date1 == date2) {
        return true
    }

    return false
});

/* we need a for loop */
Handlebars.registerHelper('for', function(from, to, incr, block) {
    var accum = '';
    for(var i = from; i < to; i += incr)
        accum += block.fn(i);
    return accum;
});

/**
 *
 * @param {Array} arr
 * @param {string} key
 */
function ksort(arr){
    let keys = Object.keys(arr)
    keys.sort()
    let result = {}
    for(var key in keys){
        result[keys[key]] = arr[keys[key]]
    }
    return result;
}

function getDate(i , formated, short) {

    let daydate = new Date()

    if (i > 0) {
        let newdate = new Date();
        newdate.setDate(newdate.getDate() + i);

        daydate = new Date(newdate)
    }
    let todayDate = daydate.toISOString().slice(0,10);
    let date = Moment(todayDate, "YYYY-MM-DD").locale('de')

    if (short ) {
        let format = 'dd DD.MM'
        return date.format(format)
    }
    else if (formated){
        let format = 'dd DD.MM.YY'
        return date.format(format)
    }
    else {
        let format = 'Y-MM-DD'
        return date.format(format)
    }


}

/**
 * keyBy from Laravel
 * https://github.com/laravel/framework/blob/5.6/src/Illuminate/Support/Collection.php#L777
 * @param {Array} arr
 * @param {string} keyBy
 */
function keyBy(arr, keyBy)
{
    let results = []
    for(let key in arr)
    {
        let item = arr[key]
        if(item == null)
        {
            continue
        }
        let resolvedKey = item[keyBy]
        if(resolvedKey == null)
        {
            results.push(item)
        }else{
            results[resolvedKey] = item
        }
    }
    return results
}

/**
 * sortBy from Laravel
 * https://github.com/laravel/framework/blob/5.6/src/Illuminate/Support/Collection.php#L1463
 * @param {Array} arr
 * @param {string} prop
 */
function sortBy(arr, prop){
    arr.sort(function(obj1, obj2){
        return obj1[prop] - obj2[prop]
    })
    return arr
}

